import { tagGroups } from '@hungryroot/tags';
import { ControlTagSelect } from '../../components/ControlTagSelect/ControlTagSelect';
import { QuizFieldset } from '../../components/QuizFieldset/QuizFieldset';
import { QuizQuestionScreen } from '../../components/QuizQuestionScreen/QuizQuestionScreen';
import { SectionLabel } from '../../components/SectionLabel/SectionLabel';
import { Toggle, ToggleVariant } from '../../components/Toggle/Toggle/Toggle';
import { type Quiz } from '../../defs/quiz';

import styles from './BudgetQuestion.module.css';

interface Props {
  testid: string;
  quiz: Quiz;
}

export function BudgetQuestion(props: Props) {
  const { testid } = props;

  return (
    <QuizQuestionScreen
      testid={testid}
      heroText="How much do you spend on food each week?"
      subCopy="Include grocery stores and restaurants."
      sectionLabel={<SectionLabel label="About you" />}
    >
      <QuizFieldset scrollToTop>
        <ControlTagSelect
          ariaLabel="Select your grocery budget"
          tagGroupId={tagGroups.budget}
          question="budget"
          layoutVariant="one-column"
          max={1}
          defaultValue={undefined}
          staticList
        >
          {({ active, tag, index }) => {
            const { id: tagId, name: tagName } = tag;
            return (
              <Toggle
                active={active}
                testid={`${testid}-toggle-tag-${tagId}`}
                label={tagName}
                variant={ToggleVariant.Two}
                style={{ animationDelay: `${0.05 * index + 0.5}s` }}
                className={styles['margin-100']}
              />
            );
          }}
        </ControlTagSelect>
      </QuizFieldset>
    </QuizQuestionScreen>
  );
}
